'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { OrderedMap } from 'immutable';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import UIList from 'UIComponents/list/UIList';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import Networks from 'ads-account-connection/lib/Networks';
import InstallPixelModal from 'ads-account-connection/components/audiences/InstallPixelModal';
import NetworkSelectBox from 'ads-account-connection/components/NetworkSelectBox';
import FacebookPixelModal from 'ads-account-connection/components/FacebookPixelModal';

const NetworkSelectPixelModal = ({
  adAccounts,
  installPixels,
  loading,
  onClose,
  onRefreshPixels,
  pixelsByNetwork,
  starterUpgradeData,
  trackEvent,
  eventCount,
  eventLimit,
  isEventCreation = false,
  onAuth,
  isProOrEnterprise,
  hasFacebookCapiFormEventsUpdates
}) => {
  const [openFBPixelModal, setOpenFBPixelModal] = useState(false);
  const [openPixelModal, setOpenPixelModal] = useState(false);
  const [selectedNetwork, setSelectedNetwork] = useState(null);

  const handleNetworkClick = network => {
    trackEvent('conversionsEventActions', {
      action: 'Clicked network selection to add a pixel',
      network
    });
    setSelectedNetwork(network);

    if (network !== Networks.FACEBOOK) {
      setOpenPixelModal(true);
    } else {
      setOpenFBPixelModal(true);
    }
  };

  if (openPixelModal) {
    const pixelsByNetworkSelected = OrderedMap({
      [selectedNetwork]: pixelsByNetwork.get(selectedNetwork)
    });
    return /*#__PURE__*/_jsx(InstallPixelModal, {
      adAccounts: adAccounts,
      installPixels: installPixels,
      loading: loading,
      onClose: () => {
        onClose();
        setOpenPixelModal(false);
      },
      pixelsByNetwork: pixelsByNetworkSelected,
      starterUpgradeData: starterUpgradeData,
      trackEvent: trackEvent
    });
  }

  if (openFBPixelModal) {
    const facebookPixels = pixelsByNetwork.get(Networks.FACEBOOK);
    return /*#__PURE__*/_jsx(FacebookPixelModal, {
      adAccounts: adAccounts,
      installPixels: installPixels,
      loading: loading,
      onClose: () => {
        onClose();
        setOpenFBPixelModal(false);
      },
      onRefreshPixels: onRefreshPixels,
      facebookPixels: facebookPixels,
      starterUpgradeData: starterUpgradeData,
      trackEvent: trackEvent,
      eventCount: eventCount,
      eventLimit: eventLimit,
      isEventCreation: isEventCreation,
      onAuth: onAuth,
      isProOrEnterprise: isProOrEnterprise,
      hasFacebookCapiFormEventsUpdates: hasFacebookCapiFormEventsUpdates
    });
  }

  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "install-pixel-network-select-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ADS_ACCOUNT_CONNECTION.conversionsApi.selectNetwork"
        })
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      className: "p-x-6",
      children: /*#__PURE__*/_jsx(UIList, {
        inline: true,
        childClassName: "m-bottom-6 text-center",
        children: Object.keys(Networks).map(network => /*#__PURE__*/_jsx(NetworkSelectBox, {
          disabled: !(pixelsByNetwork && pixelsByNetwork.has(network)),
          network: network,
          onClick: () => handleNetworkClick(network),
          isProOrEnterprise: isProOrEnterprise
        }, network))
      })
    })]
  });
};

export default NetworkSelectPixelModal;